import React from "react";

const logos = [
  "/client1.jpeg",
  "/client2.jpeg",
  "/client3.jpeg",
  "/client4.jpeg",
  "/client5.jpeg",
  "/client6.jpeg",
];

export default function OurClients() {
  return (
    <section className="bg-gray-100 py-12 overflow-hidden">
      <div className="mx-auto">

        {/* Heading */}
        <h2 className="text-3xl font-bold text-center mb-10 font-PTSerif-Regular text-gray-900">
          Our Associates
        </h2>

        <div className="relative w-full overflow-hidden">
          <div className="flex animate-scroll gap-10 w-max">
            {[...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="w-[220px] h-[120px] flex items-center justify-center px-2"
              >
                <img
                  src={logo}
                  alt="client"
                  className="h-16 object-contain opacity-80"
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}